<div> 
  <h2 class="dialog-box__title">La contraseña informada no respeta las siguientes reglas:</h2>
  <ul class="dialog-box__content">
    <li class="dialog-box__list__item" *ngFor="let item of data.passwordPolicies">- {{item}}</li>
    <li class="dialog-box__list__item" *ngFor="let item of data.passwordRestrictions">- No uses {{item}}</li>
    <li class="dialog-box__list__item" *ngFor="let item of data.passwordForbiddenWords">- No uses {{item}}</li>
  </ul>
</div>
<div class="dialog-box__exit__button">
  <button mat-stroked-button (click)="onNoClick()" class="dialog-box_exit_button_text">
    OK
  </button>
</div>